module.exports = __webpack_public_path__ + "img/7-3.27f4e5ff.webp";